import { IThemeColors } from '../interfaces/i-theme-colors';
import { IStaticThemeColors } from '../interfaces/i-static-theme-colors';
import { IDynamicThemeColors } from '../interfaces/i-dynamic-theme-colors';

export const staticColors: IStaticThemeColors = {
  transparent: 'transparent',
  green: '#1FC16B',
  blue: '#335cff',
  orange: '#ff8447',
  red: '#fb3748',
  yellow: '#f6b51e',
  purple: '#7d52f4',
  sky: '#47c2ff',
  pink: '#fb4ba3',
  teal: '#22d3bb',
  grey: '#717784',
  background: '#F9FAFB',
  container_background: '#FFFFFF',
};

export const lightDynamicColors: IDynamicThemeColors = {
  primary: '#d8ff00',
  neutral1000: '#FFFFFF',
  neutral950: '#F2F2F2',
  neutral900: '#E5E5E5',
  neutral800: '#C7C7C7',
  neutral750: '#B8B8B8',
  neutral700: '#A8A8A8',
  neutral650: '#9A9A9A',
  neutral600: '#8A8A8A',
  neutral500: '#6B6B6B',
  neutral400: '#4C4C4C',
  neutral300: '#2F2F2F',
  neutral200: '#262626',
  neutral100: '#1C1C1C',
  neutral50: '#121212',
  neutral0: '#000000',
};

export const darkDynamicColors: IDynamicThemeColors = {
  primary: '#d8ff00',
  neutral1000: '#000000',
  neutral950: '#101010',
  neutral900: '#1C1C1C',
  neutral800: '#262626',
  neutral750: '#292929',
  neutral700: '#2F2F2F',
  neutral650: '#3B3B3B',
  neutral600: '#4C4C4C',
  neutral500: '#6B6B6B',
  neutral400: '#8A8A8A',
  neutral300: '#A8A8A8',
  neutral200: '#C7C7C7',
  neutral100: '#E5E5E5',
  neutral50: '#F2F2F2',
  neutral0: '#FFFFFF',
};

export const getDynamicThemeColors = (
  theme: 'light' | 'dark'
): IThemeColors => {
  return {
    ...staticColors,
    ...(theme === 'light' ? lightDynamicColors : darkDynamicColors),
  };
};
